module.exports = __webpack_public_path__ + "img/bus-round-front-outline-grey.bdbd38fd.svg";